// Central sign-out hand-off.
//
// Supabase's OAuth server exposes no `end_session_endpoint` (verified against
// the identity project's OIDC discovery document), so RP-initiated logout is
// not available. Clearing the portal's own Supabase session therefore leaves the
// central l2u-identity session alive, and the next sign-in is silent and
// credential-free.
//
// The workaround is a non-standard sign-out route on the central login app which
// clears ITS session and then returns here. This builds that URL.
//
// Returns null when unconfigured, which is the safe default: the caller stays
// local, so logout still ends the portal session rather than failing.
//
// VITE_IDENTITY_LOGOUT_URL is a BUILD-time value (Vite inlines it into the
// bundle), so it lives in the Cloudflare Pages project's environment variables —
// not in a Worker binding, and not anywhere it can be changed without a rebuild.
// Setting it requires a new build to take effect; retrying a deploy of an
// existing build will not pick it up. Unset, the symptom is silent: sign-out
// still lands on /admin/signed-out, but the central session survives and the
// next sign-in needs no credentials. To confirm a build has it, grep the served
// bundle for the identity host.
//
// The central route this points at is l2u-identity's /logout (its PR #11). It
// only redirects back to origins in that app's own VITE_LOGOUT_ALLOWED_ORIGINS
// allow-list, so this portal's origin must appear there too.
export function buildIdentityLogoutUrl(
  logoutBase: string | undefined,
  returnTo: string,
  reason?: string,
): string | null {
  const base = (logoutBase ?? '').trim().replace(/\/+$/, '');
  if (!base) return null;
  const separator = base.includes('?') ? '&' : '?';
  const url = `${base}${separator}redirect_to=${encodeURIComponent(returnTo)}`;
  // redirect_to is always written first, so reason's separator is always '&'.
  return reason ? `${url}&reason=${encodeURIComponent(reason)}` : url;
}
